import { observable, computed, action } from 'mobx'
import { ConfirmDialogState } from 'components/ConfirmDialog'
import LinkAccountDialogState from 'components/LinkAccountDialog/LinkAccountDialogState'

export default class LinkedAccountsManagerState {
  // used in the confirm dialog
  @observable accountToRemove = null
  @observable linkAccountDialog = null
  @observable removeLinkedAccountDialog = null

  constructor ({ rootStore }) {
    this.rootStore = rootStore
    this.linkAccountDialog = new LinkAccountDialogState({ rootStore: this.rootStore })
    this.removeLinkedAccountDialog = new ConfirmDialogState()
  }

  @computed get linkedAccounts () {
    return this.rootStore.linkedAccountStore.linkedAccounts.map(x => x)
  }

  async loadAccounts () {
    await this.rootStore.linkedAccountStore.fetchLinkedAccounts()
  }

  @action async showDialog () {
    this.linkAccountDialog = new LinkAccountDialogState({ rootStore: this.rootStore })
    await this.linkAccountDialog.linkNewAccount()
  }

  @action removeAccount (account) {
    this.accountToRemove = account
    return this.removeLinkedAccountDialog.show().then((yes) => {
      if (yes) {
        return this.rootStore.linkedAccountStore.destroy(account)
      }
    })
  }

  @action fixIssues (account) {
    this.linkAccountDialog = new LinkAccountDialogState({ rootStore: this.rootStore })
    this.linkAccountDialog.updateAccount(account)
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkedAccountsManager/LinkedAccountsManagerState.js